import { t } from "@/i18n-js/instance";
import { useQuizResultModal } from "@/react/components/Spaces/CourseSpace/AdminSummary/Engagement/QuizResults/Modal";
import { Button } from "@circle-react-uikit/Button";
import type { QuizAttemptWithCommunityMember } from "./index";

interface ActionButtonProps {
  attempt: QuizAttemptWithCommunityMember;
  refetchAttempts: () => void;
}
export const ActionButton = ({
  attempt,
  refetchAttempts,
}: ActionButtonProps) => {
  const translationRoot =
    "courses.admin_summary.engagement.quiz_results.actions";
  const variant = attempt.result == "pending" ? "circle" : "secondary";
  const buttonLabel = t([
    translationRoot,
    attempt.result == "pending" ? "grade_quiz" : "view_result",
  ]);
  const quizResultModal = useQuizResultModal();

  return (
    <Button
      variant={variant}
      type="button"
      className="!px-3 !py-1.5 md:!w-full"
      onClick={() =>
        quizResultModal.show({
          quizId: attempt.quiz_id,
          attemptId: attempt.id,
          student: attempt.community_member,
          refetchAttempts,
        })
      }
    >
      {buttonLabel}
    </Button>
  );
};
